<template>
	<div>
		<ed-modal 
			:title="parent.formData.id == 0 ? 'Nova Categoria' : 'Editar Categoria '+parent.formData.nome+' :: '+tabela.nome" 
			:modal="showFormEdit" 
			:loadingSave="config.loading.save"
			:onSave="salvar"
			width="70%"
		>
			<div slot="modal-content" v-loading="config.loading.content">
				<ed-form :data="parent.formData" :config="config" :response="response" :itens="formItems">
					<div slot="form-footer"></div>
				</ed-form>
			</div>
		</ed-modal>
	</div>
</template>

<script>

	import Rest from 'common/rest'
	import EdForm from 'common/form'
	import EdModal from 'common/modal'
	import FormItems  from '../_form/tabela-categoria-cadastrar'

  	export default {
  		name:"empresa",
  		components: {EdForm,EdModal},
		mixins:[Rest],
		props:{
            tabela:{
                type: Object,
                default: null
			},
			showForm:{
                type: Boolean,
                default: false
			},
			parent:{
				type: Object,
                default: null
			}
		},
		watch:{
			'tabela.id'(){
				this.getTabelaDinamicaCategoria();
			},
			'parent.formData.id'(){
				this.getTabelaDinamicaCategoria();
			},
			'parent.showFormVersao'(){
				this.showFormEdit = !this.showFormEdit;
			}
		},
  		data () {
		   	return {
				config:{
					click:{
					},
					loading:{
						content:false,
						save:false,
					},
					disabled:{
						versao:true
					},
				},
				response:{},
				formItems:[],
				showFormEdit:false
			}
		},

		created(){
		},

		mounted: function() {
			this.formItems = FormItems;
			this.getTabelaDinamicaCategoria();
		},
		methods: {

			getTabelaDinamicaCategoria: function(){

				if(this.parent.formData.id == 0)return;

				this.config.loading.content = true;
				this.response = {};

				this.get('/ltcat/tabela-dinamica/categoria/'+this.tabela.id+'/'+this.parent.formData.id).then((result)=>{
           			result = result[0];

					this.config.loading.content = false;
					this.response = {};

					if(result.status == 200){
						this.parent.formData ={
							id: result.data.id,
							nome: result.data.nome,
							updated_at: result.data.updated_at,
							usuario: result.data.usuario,
							ativo:result.data.ativo
						};
					}
				});
			},

			salvar: function(){
				
				this.config.loading.save = true;
				this.response = {};

				this.post('/ltcat/tabela-dinamica/categoria/'+this.tabela.id+'/editar',this.parent.formData).then((result)=>{

					result = result[0];
						
					this.config.loading.save = false;
					this.response = result;
					
					if(result.status == 200){
						this.edMsg('Dados atualizados')
						this.parent.getTabelaDinamicaCategoria();
						this.showFormEdit = !this.showFormEdit;
					}
				});
			}

		}
  	}
</script>


// WEBPACK FOOTER //
// editar.vue?c67c8b50